// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import SellDeliveryman from "views/SellDeliveryman/SellDeliveryman";


const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Início",
    icon: Dashboard,
    component: SellDeliveryman,
    layout: "/deliveryman"
  }
];

export default dashboardRoutes;
